module.exports = __webpack_public_path__ + "img/icon-linkedin.3dd79992.svg";